/** @jsxImportSource @emotion/react */

export default function CheckboxIcon({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      css={{
        ...(props.css ? props.css : {}),
      }}
      {...props}
    >
      <rect
        x="5.98047"
        y="7.18884"
        width="13.9533"
        height="14"
        fill="#E4DED6"
      />
      <rect x="4.48633" y="5.5" width="13.95" height="14" stroke="#4E5661" />
      <path
        d="M22.3457 4.1888L11.1863 16.6977L6.29109 11.9196"
        stroke="#3EBEB0"
      />
    </svg>
  );
}
